<template>
  <div>
    <svg :viewBox="viewBox" preserveAspectRatio="xMinYMin meet" class="svg-content">
      <g>
        <template v-for="(hole, index) in holes">
          <harmap-col :key="hole"
                      :x="xColCoord(index)" :y="yColCoord()"
                      :hole-number="index"
                      :max-blow="maxblow" :max-draw="maxdraw" :hole="hole"></harmap-col>
        </template>
      </g>
    </svg>
  </div>
</template>

<script>
import HarmapCol from './HarmapCol'

import { xColCoord, yColCoord, gridWidth, gridHeight } from '../grid'
import { fromPattern } from '../harmonica'

export default {
  name: 'harmap-grid',

  props: ['pattern', 'harpKey'],

  components: { HarmapCol },

  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },

  data () {
    return {
      landscape: window.innerHeight > window.innerWidth
    }
  },

  computed: {
    width () { return gridWidth(this.harmo) },
    height () { return gridHeight(this.harmo) },
    harmo () { return fromPattern(this.pattern, this.harpKey) },
    holes () { return this.harmo.holes },
    maxblow () { return this.harmo.maxBlowbends() },
    maxdraw () { return this.harmo.maxDrawbends() },
    viewBox () { return [0, 0, this.width, this.height].join(' ') },
    innerHeight () { return window.innerHeight },
    innerWidth () { return window.innerWidth }
  },

  methods: {
    xColCoord,
    yColCoord,
    handleResize (event) {
      this.landscape = event.currentTarget.innerHeight > event.currentTarget.innerWidth
    }
  }
}
</script>

<style scoped>
svg {
  background-color: lightgray;
}
.svg-container {
  display: inline-block;
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  vertical-align: middle;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// HarmapGrid.vue?13ba36d1